var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetaListaBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.743,
    height: 10.115,
    viewBox: "0 0 6.743 10.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_3994376_arrow_back_left_navigation_previous_icon",
    "data-name": "3994376_arrow_back_left_navigation_previous_icon",
    d: "M26.16,17.055l4.28-3.567a.843.843,0,1,0-1.08-1.3L24.3,16.407a.844.844,0,0,0,0,1.3l5.057,4.214a.843.843,0,0,0,1.08-1.3Z",
    transform: "translate(30.743 22.112) rotate(180)",
    fill: "#d13c8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaListaBlog);
export default __webpack_public_path__ + "static/media/seta-lista-blog.9f76135c9cf9e97d27099d6f26b55a10.svg";
export { ForwardRef as ReactComponent };